import { observable, action, makeObservable } from 'mobx';
class User {
    constructor() {
        makeObservable(this);
    }
    //登录按钮loading
    @observable
    btnLoading = false;
    @action
    setBtnLoading = (val) => {
        this.btnLoading = val;
    };
    //用户信息
    @observable
    userInfo = {};
    @action
    setUserInfo = (data) => {
        this.userInfo = data;
    };
    // 登录表单信息
    @observable
    loginInfo = {
        username: '',
        password: '',
        remember: true
    };


}

export default new User();
